export const hasMeaningfulAnswer = (answer) => {
  if (answer === null || answer === undefined) return false;
  if (typeof answer === "string") return answer.trim().length > 0;
  if (Array.isArray(answer)) return answer.length > 0;
  return true;
};

export const hasName = (profile) =>
  Boolean(profile?.firstName && profile?.lastName);

export const hasPhoto = (profile) =>
  Boolean(profile?.imageUrl || profile?.profileImage);

export const buildRequirements = ({ profile, descriptor, questions }) => {
  const requirements = [];

  requirements.push({
    key: "name",
    type: "name",
    label: "Your name",
    complete: hasName(profile),
  });

  if (descriptor?.photoRequired) {
    requirements.push({
      key: "photo",
      type: "photo",
      label: "A profile photo",
      complete: hasPhoto(profile),
    });
  }

  (questions || [])
    .filter((question) => question.required)
    .forEach((question) => {
      requirements.push({
        key: `question:${question._id}`,
        type: "question",
        label: question.question,
        questionId: question._id,
        complete: hasMeaningfulAnswer(question.answer),
      });
    });

  return requirements;
};

export const computeReadiness = (requirements) => {
  const total = requirements.length;
  const completed = requirements.filter((item) => item.complete).length;
  return {
    total,
    completed,
    ready: total > 0 ? completed === total : true,
  };
};

export const firstIncompleteIndex = (requirements) => {
  const index = requirements.findIndex((item) => !item.complete);
  return index === -1 ? requirements.length : index;
};
